import axios from "axios";
import { enqueue, isQueueable } from "./offlineQueue";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const csrfToken = () => document.cookie.split("; ").find((cookie) => (
  cookie.startsWith("csrf_token=")
))?.split("=")[1];

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const token = csrfToken();
  if (token && !["get", "head", "options"].includes(method)) {
    config.headers["X-CSRF-Token"] = decodeURIComponent(token);
  }
  return config;
});

// Floor actions (task start/pause/resume/complete, putaway) are queued when the network is down.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const cfg = error.config || {};
    const offline = !error.response && (!navigator.onLine || error.code === "ERR_NETWORK");
    if (offline && isQueueable((cfg.method || "").toLowerCase(), cfg.url || "")) {
      const body = typeof cfg.data === "string" ? JSON.parse(cfg.data || "{}") : cfg.data || {};
      const entry = enqueue(cfg.url, body);
      return Promise.resolve({ data: { queued: true, entry }, status: 202, offlineQueued: true });
    }
    return Promise.reject(error);
  },
);
